export enum ROUTES {
  WEEK = '/:userId/week',
  MENU_CURRENT_DAY = '/:userId/menu/:dayDate',
  CHECKOUT = '/:userId/checkout/:dayDate',
  CHECKOUT_WITH_ORDER = '/:userId/checkout/:dayDate/:orderId',
}
